export const SLUG_RE = /^[a-z][a-z0-9-]{2,30}$/;
export const RESERVED_SLUGS = ['control', 'www', 'api', 'admin', 'mail', 'sharing-control', '_deleted'];

/** Returns an error message, or null when the slug is valid. */
export function slugError(slug: string, taken: string[] = []): string | null {
  if (!slug) return 'Required';
  if (!/^[a-z]/.test(slug)) return 'Must start with a lowercase letter';
  if (slug.length < 3) return 'At least 3 characters';
  if (slug.length > 31) return 'At most 31 characters';
  if (!SLUG_RE.test(slug)) return 'Only lowercase letters, digits and dashes';
  if (slug.endsWith('-')) return 'Cannot end with a dash';
  if (RESERVED_SLUGS.includes(slug)) return 'This name is reserved';
  if (taken.includes(slug)) return 'Already used by another clone';
  return null;
}

export function slugify(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/^[^a-z]+/, '')
    .slice(0, 31);
}

const DOMAIN_RE = /^(?=.{3,253}$)([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/;
export function domainError(d: string): string | null {
  if (!d) return 'Required';
  if (!DOMAIN_RE.test(d)) return 'Not a valid domain name';
  return null;
}
